import { QueryKeys, useEntity } from "@/api/core";
import { useLoggedIn } from "@/hooks";
import { relationshipSchema } from "@/schemas";

interface UseAccountRelationshipOpts {
  enabled?: boolean;
}

function useAccountRelationship(
  accountId: string | undefined,
  opts: UseAccountRelationshipOpts = {},
) {
  const { isLoggedIn } = useLoggedIn();
  const { enabled = false } = opts;

  const { data: relationship, ...result } = useEntity({
    id: accountId!,
    queryKey: QueryKeys.relationships.byAccount(accountId!),
    endpoint: "/api/v1/accounts/relationships",
    schema: relationshipSchema,
    params: {
      id: [accountId],
    },
    enabled: isLoggedIn && enabled && !!accountId,
    staleTime: 300000, // 5 minutes
  });

  return { relationship, ...result };
}

export { useAccountRelationship };
